const EmailOverview = () => import("@/views/email-message/overview.vue");

export default [
    { path: "/email-message/overview", name: "email_message_overview", component: EmailOverview, meta: { title: "Standard mail overview" }, props: true },
];
